function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { HttpApiClient, HttpClient, HttpClientRequest } from "@effect/platform";
import { Config, Context, Effect, Layer, Option, pipe, Redacted } from "effect";
import { Api } from "../api";
const DashApiClientBaseUrl = Config.string("DASH_API_CLIENT_BASE_URL").pipe(Config.withDefault("/"));
const DashApiClientApiKey = Config.option(Config.redacted("DASH_API_CLIENT_API_KEY"));
//
// Base Client
//
const make = (options)=>HttpApiClient.make(Api, {
        baseUrl: options.baseUrl,
        transformClient: (client)=>{
            // if (Option.isNone(options.apiKey)) {
            //   return client
            // }
            // const apiKey = options.apiKey.value
            return HttpClient.mapRequest(client, (request)=>{
                var _options_additionalHeaders;
                return HttpClientRequest.setHeaders(_object_spread({}, Option.isSome(options.apiKey) ? {
                    Authorization: `Bearer ${Redacted.value(options.apiKey.value)}`
                } : {}, (_options_additionalHeaders = options.additionalHeaders) === null || _options_additionalHeaders === void 0 ? void 0 : _options_additionalHeaders.call(options)))(request);
            });
        }
    });
var _Context_Tag;
export class Client extends (_Context_Tag = Context.Tag("@superwall/api/dash-api/client")()) {
}
_define_property(Client, "make", make);
_define_property(Client, "Live", pipe(Config.unwrap({
    baseUrl: DashApiClientBaseUrl,
    apiKey: DashApiClientApiKey
}), Effect.flatMap(make), Layer.effect(Client)));
_define_property(Client, "layer", (options)=>pipe(make(options), Layer.effect(Client)));
_define_property(Client, "layerConfig", (configOptions)=>pipe(configOptions, Config.unwrap, Effect.flatMap(make), Layer.effect(Client)));
